import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ErrorNotificationService, errorMessageFor } from './error-notification.service';

/** Displays a safe notification for uncaught application exceptions. */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly notifications = inject(ErrorNotificationService);

  handleError(error: unknown): void {
    this.notifications.showError(errorMessageFor(error));
  }
}
